import { useState, useEffect } from 'react'
import { Bar } from 'react-chartjs-2';
import { findAdesaoByLastFiveDays, findAdesaoByAnoLetivo } from "./api-engajamento-diario";
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);


const useStyles = makeStyles({
    anoLetivoBtn: {
        marginLeft: 20
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    },
    paper: {
        padding: '20px',
    },
});

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Adesão',
        },
    },
};


export default function Adesao() {
    const classes = useStyles();
    const [adesao, setAdesao] = useState();
    const [chartSelected, setChartSelected] = useState('fiveLastDays');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        findAdesaoByLastFiveDays().then(data => {
            if (data.error) {
                console.log(data);
            } else {
                setAdesao(data);
                setIsLoading(false);
            }
        })


    }, []);

    const handleFiveLastDaysChart = () => {
        setAdesao(null);
        setChartSelected('fiveLastDays');
        setIsLoading(true);
        findAdesaoByLastFiveDays().then(data => {
            if (data.error) {
                console.log(data);
            } else {
                setAdesao(data);
                setIsLoading(false);
            }
        })
    }

    const handleAnoLetivoChart = () => {
        setAdesao(null);
        setChartSelected('anoLetivo');
        setIsLoading(true);
        findAdesaoByAnoLetivo().then(data => {
            if (data.error) {
                console.log(data);
            } else {
                setAdesao(data);
                setIsLoading(false);
            }
        })
    }



    return (
        <Container className={classes.paper} >
            <Typography variant="h5">
                Adesão
            </Typography>
            <Typography variant="h6">
                Buscar Por:
            </Typography>
            <Button
                variant="contained"
                color="primary"
                disabled={chartSelected === 'fiveLastDays' ? true : false}
                onClick={handleFiveLastDaysChart}
            >
                {isLoading && chartSelected === 'fiveLastDays' ? <CircularProgress className={classes.loading} color="primary" size={20} /> : ''}
                5 Últimos Dias
            </Button>
            <Button
                variant="contained"
                color="primary"
                className={classes.anoLetivoBtn}
                disabled={chartSelected === 'anoLetivo' ? true : false}
                onClick={handleAnoLetivoChart}
            >
                {isLoading && chartSelected === 'anoLetivo' ? <CircularProgress className={classes.loading} color="primary" size={20} /> : ''}
                Ano Letivo
            </Button>


            <Bar
                data={{
                    labels: adesao && adesao.listaAxeX ? adesao.listaAxeX : [],
                    datasets: [
                        {
                            label: 'Total Responsáveis/Alunos',
                            data: adesao && adesao.listaTotalRespAluno ? adesao.listaTotalRespAluno : [],
                            backgroundColor: 'rgba(255, 99, 132, 0.2)',
                            borderColor: 'rgba(255, 99, 132, 1)',
                            borderWidth: 1
                        },
                        {
                            label: 'Adesão Responsáveis/Alunos',
                            data: adesao && adesao.listaAdesaoRespAluno ? adesao.listaAdesaoRespAluno : [],
                            backgroundColor: 'rgba(255, 159, 64, 0.2)',
                            borderColor: 'rgba(255, 159, 64, 1)',
                            borderWidth: 1
                        },
                        {
                            label: 'Total Responsáveis',
                            data: adesao && adesao.listaTotalResp ? adesao.listaTotalResp : [],
                            backgroundColor: 'rgba(54, 162, 235, 0.2)',
                            borderColor: 'rgba(54, 162, 235, 1)',
                            borderWidth: 1
                        },
                        {
                            label: 'Adesão Responsáveis',
                            data: adesao && adesao.listaAdesaoResp ? adesao.listaAdesaoResp : [],
                            backgroundColor: 'rgba(255, 206, 86, 0.2)',
                            borderColor: 'rgba(255, 206, 86, 1)',
                            borderWidth: 1
                        },
                        {
                            label: 'Total Alunos',
                            data: adesao && adesao.listaTotalAluno ? adesao.listaTotalAluno : [],
                            backgroundColor: 'rgba(75, 192, 192, 0.2)',
                            borderColor: 'rgba(75, 192, 192, 1)',
                            borderWidth: 1
                        },
                        {
                            label: 'Adesão Alunos',
                            data: adesao && adesao.listaAdesaoAluno ? adesao.listaAdesaoAluno : [],
                            backgroundColor: 'rgba(153, 102, 255, 0.2)',
                            borderColor: 'rgba(153, 102, 255, 1)',
                            borderWidth: 1
                        },
                    ]
                }}
                height={200}
                width={600}
                // options={{
                //     responsive: true,
                //     maintainAspectRatio: false,
                //     scales: {
                //         yAxes: [{
                //             ticks: {
                //                 beginAtZero: true,
                //             }
                //         }]
                //     }
                // }}
                options={options}
            />
        </Container>
    );
}